import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield } from "react-icons/fi";
import InfiniteMarquee from '../home/InifiteMarquee';

function Hero({
    label = "Guardhart Security",
    title = "Security you can trust.",
    description = "Professional guards, smart CCTV, and reliable protection for businesses and homes across Kenya.",
    primaryBtnText = "Our Services",
    primaryBtnLink = "/services",
    secondaryBadgeText = "Fully Ensured",
    showSecondaryBadge = true,
    showBtn = true
}) {
    return (
        <>
            <section data-theme="guardhartDark" className="relative overflow-hidden border-b border-zinc-800">

                <div
                    className="absolute inset-0 opacity-[0.25]"
                    style={{
                        backgroundImage: `radial-gradient(circle at 1.44px 1.44px, rgb(63 63 70) 1.89px, transparent 0)`,
                        backgroundSize: '28px 28px'
                    }}
                ></div>
                <div className="absolute top-8 right-8 md:top-12 md:right-12 opacity-10 pointer-events-none">
                    <div className="relative">
                        <div className="absolute inset-0 bg-[#FFC000]/30 rounded-full blur-2xl"></div>
                        <div className="relative w-16 h-16 md:w-28 md:h-28 border border-[#FFC000]/40 rounded-full flex items-center justify-center">
                            <FiShield className="w-8 h-8 md:w-20 md:h-20 text-[#FFC000]" />
                        </div>
                    </div>
                </div>
                <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 flex flex-col items-start">

                    <span className="text-xs font-bold uppercase tracking-widest text-[#FFC000] mb-4">
                        {label}
                    </span>

                    <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-base-content mb-6 max-w-3xl leading-tight">
                        {title}
                    </h1>

                    <p className="text-base md:text-lg text-zinc-400 max-w-xl mb-8 leading-relaxed">
                        {description}
                    </p>

                    <div className="flex flex-wrap gap-4">
                        {showBtn && (
                            <Link
                                to={primaryBtnLink}
                                className="bg-[#FFC000] text-primary-content px-8 py-3 text-xs font-bold uppercase tracking-widest hover:brightness-110 hover:shadow-lg hover:shadow-[#FFC000]/20 transition-all rounded active:scale-95"
                            >
                                {primaryBtnText}
                            </Link>
                        )}

                        {showSecondaryBadge && (
                            <div className="flex items-center gap-3 px-6 py-3 border border-zinc-800 bg-zinc-900/50 backdrop-blur-sm rounded hover:border-[#FFC000]/30 transition-all">
                                <FiShield className="text-[#FFC000] w-5 h-5" />
                                <span className="text-sm text-zinc-100">{secondaryBadgeText}</span>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <InfiniteMarquee />
        </>
    );
}

export default Hero;